import "./scss/custom";
import "intersection-observer";
import scrollama from "scrollama";

const sections = document.querySelectorAll(".section");

const scrollerDict = {};

sections.forEach(section => {
  console.log(section.id);
  // instantiate the scrollama
  scrollerDict[section.id] = scrollama();
  // setup the instance, pass callback functions
  scrollerDict[section.id]
    .setup({
      step: `#${section.id} .step`,
      offset: 0.65
    })
    .onStepEnter(response => {
      console.log(response);
      const steps = section.querySelectorAll(".step-image");
      steps.forEach((s, i) => {
        if (i === response.index) {
          s.classList.add("active");
        } else {
          s.classList.remove("active");
        }
      });
      // { element, index, direction }
    })
    .onStepExit(response => {
      // const steps = section.querySelectorAll(".step-image");
      // steps.forEach((s, i) => {
      //   if (i === response.index) {
      //     s.classList.add("active");
      //   } else {
      //     s.classList.remove("active");
      //   }
      // });
    });

  // setup resize event
  window.addEventListener("resize", scrollerDict[section.id].resize);
});
